export default (type) =>
  ['Boolean', 'Checkbox', 'Radio', 'RadioLarge', 'TextBoolean'].includes(type);
